import React from 'react';
import { Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white mt-20">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left">
            <p className="text-gray-900 font-serif text-lg mb-2">Keith Romero</p>
            <p className="text-gray-600 text-sm">Writer of fiction and essays</p>
          </div>

          <div className="flex items-center gap-6">
            <a
              href="mailto:keith.romero@example.com"
              className="text-gray-600 hover:text-gray-900 transition-colors duration-200 flex items-center gap-2"
            >
              <Mail size={18} />
              <span className="text-sm">Get in touch</span>
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-200 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Keith Romero. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;